/**
 * @generated SignedSource<<16a63b4f77568408079c7ea8e6d0ca30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TableFocus_tableWidget$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_table">;
  readonly " $fragmentType": "TableFocus_tableWidget";
};
export type TableFocus_tableWidget$key = {
  readonly " $data"?: TableFocus_tableWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"TableFocus_tableWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TableFocus_tableWidget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTable_table"
    }
  ],
  "type": "WidgetTable",
  "abstractKey": null
};

(node as any).hash = "81971afc8038333286cef80a82e9c8c9";

export default node;
